import React, { useState, useEffect, useCallback } from 'react'
import {
  NavItem,
  NavLink as ReactStrapNavLink,
} from 'reactstrap'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { commonActions } from '../../../actions/commonActions'
import userApi from '../../../api/UserApi'
import { Loader } from '../loader/Loader'
import * as commonSelectors from '../selectors'
import { isNullOrEmpty } from '../../../shared/scripts'
import './navMenu.css'

const serverName = 'Bonus.Integrations';

const NavMenu = ({
  redirecting = () => null,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isLiveEnv, setIsLiveEnv] = useState(false);

  const environment = useSelector(commonSelectors.environment);
  const isAuthorized = useSelector(commonSelectors.isAuthorized);
  const userRights = useSelector(commonSelectors.userRights);

  useEffect(() => {
    setIsLiveEnv(environment === 'LIVE');
  }, [environment]);

  const handleToggle = useCallback(() => setIsExpanded(!isExpanded), [isExpanded]);

  return (
    <header>
      <nav
        className={`bon-navbar border-bottom-${isLiveEnv ? 'live' : 'dev'}${isExpanded ? ' bon-navbar-expanded' : ''} box-shadow navbar navbar-dark bg-dark navbar-expand-lg`}
      >
        <div className="container">
          <NavbarTitle />
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#navbarOffcanvasLg"
            aria-controls="navbarOffcanvasLg"
            onClick={handleToggle}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className={`bg-dark offcanvas offcanvas-end${isExpanded ? ' show' : ''}`}
            tabIndex="-1"
            id="navbarOffcanvasLg"
            aria-labelledby="navbarOffcanvasLgLabel"
            aria-modal={isExpanded}
            role={isExpanded ? 'dialog' : null}
          >
            <div className="offcanvas-header">
              <h5
                className="offcanvas-title text-light"
                id="offcanvasNavbarLabel"
              >
                {
                  serverName
                }
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                onClick={handleToggle}
              />
            </div>
            <div className="offcanvas-body">
              <NavbarList>
                {isAuthorized === true && <>
                  {userRights.fullControl === true &&
                    <NavbarListLink
                      tag={Link}
                      className="text-light"
                      to="/clientapp/configuration"
                    >
                      Configurations
                    </NavbarListLink>
                  }
                  <NavbarListLink
                    tag={Link}
                    className="text-light"
                    to="/clientapp/semaphoreLocks"
                  >
                    Semaphore Locks
                  </NavbarListLink>
                  <NavbarListLink
                    tag={Link}
                    className="text-light"
                    to="/clientapp/app-logs"
                  >
                    Log Viewer
                  </NavbarListLink>
                </>}
                <NavbarUserLoginListItems
                  onRedirecting={redirecting}
                />
              </NavbarList>
            </div>
          </div>
        </div>
      </nav>
    </header>
  )
}

const NavbarList = ({ children }) => (
  <ul
    className="navbar-nav justify-content-end flex-grow-1 pe-3"
  >
    {children}
  </ul>
);

const NavbarListLink = ({
  to = '#',
  title = '',
  className = '',
  children,
}) => (
  <li className="nav-item">
    <NavLink
      tag={Link}
      className={"nav-link " + className}

      to={to}
      title={title}
    >
      {children}
    </NavLink>
  </li>
);

const NavbarUserLoginListItems = ({
  onRedirecting,
}) => {
  const [isUncAuthorizedState, setIsUncAuthorizedState] = useState(false);
  const isAuthorized = useSelector(commonSelectors.isAuthorized);
  const dispatch = useDispatch();

  useEffect(() => {
    setIsUncAuthorizedState(isAuthorized !== false && isAuthorized !== true);
  }, [isAuthorized]);

  const handleLogin = useCallback(() => {
    onRedirecting();
    userApi.login();
  }, [onRedirecting]);

  const handleLogout = useCallback(() => {
    onRedirecting();
    dispatch(commonActions.logout());
  }, [onRedirecting, dispatch]);

  return (<>
    {isUncAuthorizedState &&
      <NavItem>
        <NavLink className="user">Checking state...</NavLink>
      </NavItem>
    }
    <li className="nav-item">
      <ReactStrapNavLink
        tag={Link}
        className="text-light"
        to="#"
        onClick={isAuthorized ? handleLogout : handleLogin}
      >
        <b>{isAuthorized ? 'Logout' : 'Login'}</b>
      </ReactStrapNavLink>
      {isUncAuthorizedState &&
        <Loader
          isloading={true}
        />
      }
    </li>
  </>);
}

const NavbarTitle = () => {
  const instanceId = useSelector(commonSelectors.instanceId);

  return (
    <div
      className="navbar-brand-container"
    >
      <NavLink
        tag={Link}
        to=''
        className="navBrand"
      >
        {serverName}
      </NavLink>
      {!isNullOrEmpty(instanceId) &&
        <div className="under-brand">
          <span>{`[${instanceId?.substring(0, 16) ?? 'unknown'}]`}&nbsp;</span>
        </div>
      }
    </div>
  );
}

const NavLink = ({
  to,
  title,
  children,
  className,
}) => {
  return (
    <ReactStrapNavLink
      tag={Link}
      className={className}
      to={to}
      title={title}
    >
      {children}
    </ReactStrapNavLink>
  );
}


export default NavMenu;